<template>
  <div class="detok-landing">
    <div class="animated-bg" />
    <div class="particles" aria-hidden="true">
      <div v-for="n in 5" :key="n" class="particle" />
    </div>

    <nav class="dl-nav">
      <div class="logo">DeTok</div>
      <div class="nav-main">
        <div class="nav-links">
          <a href="#features" @click.prevent="scrollTo('features')">{{ t.nav.features }}</a>
          <a href="#earn" @click.prevent="scrollTo('earn')">{{ t.nav.earn }}</a>
          <a href="#download" @click.prevent="scrollTo('download')">{{ t.nav.download }}</a>
        </div>
        <div class="lang-switch">
          <button
            v-for="opt in langOptions"
            :key="opt.value"
            type="button"
            class="lang-btn"
            :class="{ active: language === opt.value }"
            @click="setLanguage(opt.value)"
          >
            {{ opt.label }}
          </button>
        </div>
      </div>
    </nav>

    <section class="hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>{{ t.hero.title }}</h1>
          <p>{{ t.hero.subtitle }}</p>
          <a href="javascript:void(0)" class="download-btn" @click.prevent="scrollTo('download')">
            <span>{{ t.hero.cta }}</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
        <div class="hero-image">
          <img :src="heroImg" :alt="t.hero.imgAlt" />
        </div>
      </div>
    </section>

    <section id="features" class="features">
      <h2 class="section-title">{{ t.featuresTitle }}</h2>
      <div class="features-grid">
        <div v-for="(f, i) in t.features" :key="i" class="feature-card">
          <div class="feature-icon">
            <img :src="featureImgs[i]" :alt="f.title" />
          </div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </section>

    <section id="earn" class="earn-section">
      <div class="earn-content">
        <h2 class="section-title">
          {{ t.earnTitleBefore }}<span>{{ t.earnTitleHighlight }}</span>
        </h2>
        <p>{{ t.earnSubtitle }}</p>
        <div class="earn-grid">
          <div v-for="(s, i) in t.steps" :key="i" class="earn-step">
            <div class="step-number">{{ i + 1 }}</div>
            <h4>{{ s.title }}</h4>
            <p>{{ s.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="download" class="download-section">
      <h2>{{ t.downloadTitle }}</h2>
      <p>{{ t.downloadSubtitle }}</p>
      <div class="download-buttons">
        <a
          :href="downloadUrl.ios"
          class="store-btn"
          target="_blank"
          rel="noopener noreferrer"
          @click="onDownloadLinkClick"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
            />
          </svg>
          <span>{{ t.ios }}</span>
        </a>
        <a
          :href="downloadUrl.android"
          class="store-btn"
          target="_blank"
          rel="noopener noreferrer"
          @click="onDownloadLinkClick"
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12l-9.85 9.85c-.5-.25-.84-.76-.84-1.35zm13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27zm3.35-4.31c.34.27.59.69.59 1.19s-.22.9-.57 1.18l-2.29 1.32-2.5-2.5 2.5-2.5 2.27 1.31zM6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z"
            />
          </svg>
          <span>{{ t.android }}</span>
        </a>
      </div>
    </section>

    <footer class="dl-footer">
      <div class="footer-logo">DeTok</div>
      <div class="footer-links">

      </div>
      <p class="copyright">{{ t.copyright }}</p>
    </footer>

    <van-overlay :show="browerFlag" z-index="2000" @click="controlBrower">
      <img src="@/common/img/DeTok/webdown.png" class="img-brower" alt="" />
    </van-overlay>
  </div>
</template>

<script>
import { handleSysLang } from '@/utils'
import { DETOK_LANDING_COPY as LANDING, DETOK_DOWNLOAD_URL } from '@/utils/detokLandingI18n'

export default {
  name: 'HomeDeTokLanding',
  data() {
    return {
      language: 'en',
      browerFlag: false,
      isWeixin: false,
      langOptions: [
        { value: 'zh-CN', label: '简体' },
        { value: 'zh-TW', label: '繁體' },
        { value: 'en', label: 'EN' },
      ],
      featureImgs: [
        require('@/common/img/detok-website/hero-phone.png'),
        require('@/common/img/detok-website/social-icons.png'),
        require('@/common/img/detok-website/social-icons.png'),
        require('@/common/img/detok-website/reward-coin.png'),
        require('@/common/img/detok-website/gaming-controller.png'),
        require('@/common/img/detok-website/reward-coin.png'),
      ],
      imgHero: require('@/common/img/detok-website/hero-phone.png'),
      imgHeroEn: require('@/common/img/detok-website/hero-phone.png'),
      downloadUrl: DETOK_DOWNLOAD_URL,
    }
  },
  computed: {
    t() {
      return LANDING[this.language] || LANDING.en
    },
    heroImg() {
      return this.language === 'en' ? this.imgHeroEn : this.imgHero
    },
  },
  mounted() {
    this.detectClient()
    this.language = handleSysLang()
    this.applyMeta()
  },
  methods: {
    detectClient() {
      const u = window.navigator.userAgent
      this.isWeixin = !!/MicroMessenger/i.test(u)
    },
    setLanguage(code) {
      this.language = code
      this.applyMeta()
      const isEn = code === 'en'
      try {
        sessionStorage.setItem('isEn', JSON.stringify(isEn))
        this.$store.commit('setIsEn', isEn)
      } catch (e) {
        /* ignore */
      }
    },
    applyMeta() {
      document.title = this.t.metaTitle
      document.documentElement.lang = this.language === 'en' ? 'en' : this.language
    },
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    controlBrower() {
      this.browerFlag = !this.browerFlag
    },
    onDownloadLinkClick(e) {
      if (this.isWeixin) {
        e.preventDefault()
        this.controlBrower()
      }
    },
  },
}
</script>

<style scoped>
.detok-landing {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  overflow-x: hidden;
  min-height: 100vh;
}

.detok-landing * {
  box-sizing: border-box;
}

.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a0a1a 0%, #1a1a3a 50%, #2d1b4e 100%);
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.animated-bg::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.3) 0%, transparent 50%);
  animation: dl-pulse 8s ease-in-out infinite;
}

@keyframes dl-pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.particles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255, 107, 107, 0.6);
  border-radius: 50%;
  animation: dl-float 15s infinite;
  left: 10%;
}

.particle:nth-child(2) {
  left: 20%;
  animation-delay: 2s;
  background: rgba(102, 126, 234, 0.6);
}
.particle:nth-child(3) {
  left: 40%;
  animation-delay: 4s;
  background: rgba(118, 75, 162, 0.6);
}
.particle:nth-child(4) {
  left: 60%;
  animation-delay: 6s;
}
.particle:nth-child(5) {
  left: 80%;
  animation-delay: 8s;
  background: rgba(102, 126, 234, 0.6);
}

@keyframes dl-float {
  0%,
  100% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(720deg);
    opacity: 0;
  }
}

.dl-nav {
  padding: 20px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  background: rgba(10, 10, 26, 0.8);
  backdrop-filter: blur(10px);
}

.nav-main {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.logo {
  font-size: 32px;
  font-weight: 800;
  color: #ff6b6b;
  text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
}

.nav-links {
  display: flex;
  gap: clamp(16px, 4vw, 40px);
}

.nav-links a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 16px;
  transition: all 0.3s;
  position: relative;
  cursor: pointer;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #ff6b6b, #667eea);
  transition: width 0.3s;
}

.nav-links a:hover {
  color: #fff;
}

.nav-links a:hover::after {
  width: 100%;
}

.lang-switch {
  display: flex;
  gap: 8px;
  align-items: center;
}

.lang-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.85);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.lang-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

.lang-btn.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  border-color: transparent;
  color: #fff;
}

.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 20px 80px;
  position: relative;
  z-index: 1;
}

.hero-content {
  display: flex;
  align-items: center;
  gap: 80px;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-text {
  flex: 1;
  color: white;
}

.hero-text h1 {
  font-size: 64px;
  font-weight: 800;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #fff 0%, #667eea 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-text p {
  font-size: 24px;
  opacity: 0.9;
  margin-bottom: 40px;
  color: rgba(255, 255, 255, 0.8);
}

.hero-image {
  flex: 1;
  display: flex;
  justify-content: center;
}

.hero-image img {
  width: 100%;
  max-width: 400px;
  border-radius: 30px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
  animation: dl-float-image 3s ease-in-out infinite;
}

@keyframes dl-float-image {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  color: white;
  padding: 18px 45px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 18px;
  transition: all 0.3s;
  box-shadow: 0 10px 30px rgba(255, 107, 107, 0.4);
  border: none;
  cursor: pointer;
}

.download-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(255, 107, 107, 0.6);
}

.features {
  padding: 100px 50px;
  background: rgba(255, 255, 255, 0.03);
  position: relative;
  z-index: 1;
}

.section-title {
  text-align: center;
  font-size: 48px;
  margin-bottom: 60px;
  color: white;
  font-weight: 700;
}

.section-title span {
  background: linear-gradient(135deg, #ff6b6b 0%, #667eea 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 24px;
  text-align: center;
  transition: all 0.4s;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ff6b6b, #667eea);
  transform: scaleX(0);
  transition: transform 0.4s;
}

.feature-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.feature-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 25px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feature-card h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: white;
}

.feature-card p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}

.earn-section {
  padding: 120px 50px;
  position: relative;
  z-index: 1;
}

.earn-section::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(255, 107, 107, 0.2) 0%, transparent 70%);
  pointer-events: none;
}

.earn-content {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  position: relative;
}

.earn-content > p {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 60px;
}

.earn-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
}

.earn-step {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 40px 30px;
  border-radius: 20px;
  transition: all 0.4s;
}

.earn-step:hover {
  transform: scale(1.05);
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 107, 107, 0.5);
}

.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  box-shadow: 0 10px 30px rgba(255, 107, 107, 0.4);
}

.earn-step h4 {
  font-size: 20px;
  margin-bottom: 10px;
  color: white;
}

.earn-step p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.download-section {
  padding: 120px 50px;
  text-align: center;
  background: linear-gradient(180deg, transparent 0%, rgba(255, 107, 107, 0.1) 100%);
  position: relative;
  z-index: 1;
}

.download-section h2 {
  font-size: 48px;
  margin-bottom: 20px;
  color: white;
}

.download-section > p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  margin-bottom: 50px;
}

.download-buttons {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.store-btn {
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 20px 40px;
  border-radius: 16px;
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;
}

.store-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}

.store-btn svg {
  width: 32px;
  height: 32px;
}

.store-btn span {
  font-size: 18px;
  font-weight: 600;
}

.dl-footer {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 60px 20px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.footer-logo {
  font-size: 36px;
  font-weight: 800;
  color: #ff6b6b;
  margin-bottom: 30px;
  text-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
}

.footer-links a:hover {
  color: #ff6b6b;
}

.copyright {
  font-size: 14px;
  opacity: 0.5;
}

.img-brower {
  width: 32vw;
  max-width: 280px;
  position: absolute;
  right: 5.3vw;
  top: 16px;
}

@media (max-width: 968px) {
  .hero-content {
    flex-direction: column-reverse;
    text-align: center;
    gap: 40px;
  }

  .hero-text h1 {
    font-size: 42px;
  }

  .hero-text p {
    font-size: 18px;
  }

  .hero-image img {
    max-width: 300px;
  }

  .section-title {
    font-size: 36px;
  }

  .download-section h2 {
    font-size: 36px;
  }
}

@media (max-width: 768px) {
  .dl-nav {
    padding: 15px 20px;
  }

  .nav-links {
    display: none;
  }

  .features,
  .earn-section,
  .download-section {
    padding: 80px 20px;
  }

  .nav-main {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
